/* ============================================================
   EMPRESS SIZE MEMORY (Sep 2026)
   Reads the last Find My Perfect Fit result saved in this
   browser and shows "Your Empress size" next to the size
   picker on product pages.
   Category comes from the product vendor/type Empress uses
   as the garment type (LEGGINGS, CROP TOP, HOODIE ...).
   ============================================================ */
(function () {
'use strict';
/* product-info renders this script more than once per page: run once */
if (window.__efcSizeMemory) return;
window.__efcSizeMemory = true;
var KEY = 'efc:fit:v2';
var MAX_AGE_DAYS = 180;

function read() { try { return JSON.parse(localStorage.getItem(KEY) || 'null'); } catch (e) { return null; } }

/* Map the garment type to the size we saved. */
function pick(sizes, type) {
  var t = String(type || '').toUpperCase();
  if (/BIKINI/.test(t)) return { size: sizes.bikini, label: 'bikini bottoms', alt: null };
  if (/UNDERWEAR|BRIEF|BOXER|THONG/.test(t)) return { size: sizes.underwear, label: 'underwear', alt: null };
  if (/DRESS|PYJAMA|PLAYSUIT|SKIRT|SKORT|ROBE/.test(t)) return { size: sizes.dresses, label: 'dresses', alt: sizes.dressesRoom, altLabel: 'more room' };
  if (/HOODIE|SWEATER|TSHIRT|T-SHIRT|TEE|SHIRT|JUMPER/.test(t)) return { size: sizes.tops, label: 'tops', alt: null };
  if (/CROP|BRA|SINGLET|TANK|BODYSUIT|TOP/.test(t)) return { size: sizes.crops, label: 'crops', alt: sizes.cropsAlt, altLabel: sizes.altLabel };
  if (/LEGGING|CAPRI|SHORT|YOGA|JOGGER|PANT|TIGHT|FLARE|BOOTLEG/.test(t)) return { size: sizes.bottoms, label: 'bottoms', alt: sizes.bottomsAlt, altLabel: sizes.altLabel };
  return null;
}

function init(root) {
  var saved = read();
  if (saved && (!saved.sizes || !saved.ts || (Date.now() - saved.ts) > MAX_AGE_DAYS * 864e5)) saved = null;
  root.querySelectorAll('[data-efc-memory]').forEach(function (el) {
    if (el.dataset.efcDone) return;
    /* Logged in: her account carries the result. Use it when this browser has nothing,
       or when the account copy is newer (she re-measured on another device). */
    if (el.dataset.account) {
      try {
        var acct = JSON.parse(el.dataset.account); var acctTs = acct && Date.parse(acct.updated) || 0;
        if (acct && acct.bottoms && (!saved || acctTs > (saved.ts || 0) + 60000)) saved = { ts: acctTs || Date.now(), sizes: acct };
      } catch (e) {}
    }
    if (!saved) return;
    var p = pick(saved.sizes, el.dataset.type) || pick(saved.sizes, el.dataset.type2);
    if (!p || !p.size) return;
    el.dataset.efcDone = '1';
    var hasCalc = !!document.querySelector('.efc-accordion-toggle');
    /* Second size only when the result said it was a real option (between sizes, shape flag, roomier hip). */
    var showAlt = p.alt && p.alt !== p.size && (p.label === 'dresses' || saved.sizes.altShow);
    var alt = showAlt ? ' or <b>' + p.alt + '</b>' : '';
    el.innerHTML = '<span>Your Empress size is <b>' + p.size + '</b>' + alt + '</span>' +
      (hasCalc ? '<button type="button" class="efc-your-size__edit" data-efc-open-trigger>Update</button>'
               : '<a class="efc-your-size__edit" href="/pages/sizing-chart#calculator">Update</a>');
    el.hidden = false;

  });
}

function boot() { init(document); }
if (document.readyState === 'loading') document.addEventListener('DOMContentLoaded', boot); else boot();
/* The calculator saved a fresh result (new run, or rules changed since her last one): redraw.
   Exposed on window as well as listened for, so the calculator can call it directly. */
function refresh() {
  document.querySelectorAll('[data-efc-memory]').forEach(function (el) { delete el.dataset.efcDone; el.hidden = true; });
  boot();
}
window.efcRefreshSizePill = refresh;
document.addEventListener('efc:fit-updated', refresh);
/* Prestige re-renders product info on variant change; re-run then (and once more after, for safety). */
document.addEventListener('variant:change', function () { boot(); setTimeout(boot, 50); });
document.addEventListener('product:rerender', function () { boot(); setTimeout(boot, 50); });
/* Only wake up when a size pill slot is added (quick buy, re-rendered product info), not on every app's DOM change */
function hasSlot(node) {
  return node.nodeType === 1 && (node.hasAttribute('data-efc-memory') || !!node.querySelector('[data-efc-memory]'));
}
/* Fill a new slot straight away, in the same task as the re-render: the bar never paints empty,
   so the size row doesn't jump down and back when she taps a size (James, 16 Oct). Filling only
   adds nodes inside the slot, which are not slots, so this never loops. */
new MutationObserver(function (m) {
  for (var i = 0; i < m.length; i++) {
    for (var j = 0; j < m[i].addedNodes.length; j++) {
      if (hasSlot(m[i].addedNodes[j])) { boot(); return; }
    }
  }
}).observe(document.body, { childList: true, subtree: true });
})();
